import React, { useState,useRef,useContext} from "react";
import { useTranslate } from 'react-redux-multilingual'
import { CardPerso, MatchCsv, BtnImportModel } from "@gull";
import { CSVReader } from 'react-papaparse';
import { IsAuthContext } from 'app/App';
import axios from 'axios'
import swal from "sweetalert2";

const ImportArticleSupplementListAssign = () => {
    const t = useTranslate();
    const [apiError,setApiError] = useState(false)
    const [errorCsv,setErrorCsv] = useState(false)
    const [preSendError,setPreSendError] = useState(false)
    const [showValidButton,setShowValidButton] = useState(false)
    const [resetCsv,setResetCsv] = useState(false)
    const [fileName,setFileName] = useState('');
    const [csvHeader,setCsvHeader] = useState([])
    const [csvData,setCsvData] = useState([])
    const selectMatch = useRef(new Array())
    const [isForUpdate,setIsForUpdate] = useState(false);
    const {authParam} = useContext(IsAuthContext);
    const [validButton,setValidButton] = useState(false)
    const [actionOnListItems,setActionOnListItems] = useState('ajout')

    let optionMatchCsvModelDownload = {
        [t('internalId')] : '',
        [t('supplementList')] : '',
    }

    let optionMatchCsv = [
        t('internalId')+'*',
        t('supplementList')+'*'
    ]

    let convert = {
        [t('internalId')]: 'internalid',
        [t('supplementList')]: 'supplement_list'
    }

    const handleChange = (e) =>{
        setActionOnListItems(e.target.value)
    }

    const handleOnDrop = (data,file) => {
        setApiError(false)
        setErrorCsv(false)
        setPreSendError(false)
        setShowValidButton(false)
        setResetCsv(false)
        setFileName(file.name)

        const fileSizeInMegabytes = file.size / (1024 * 1024);

        if(fileSizeInMegabytes <= 7) {
            if(data.length>process.env.REACT_APP_CSV_IMPORT_LIMIT){
                setErrorCsv(t('limitCsv',{limit: process.env.REACT_APP_CSV_IMPORT_LIMIT}))
            }
            else if(data[0].data.length!=0){
                setCsvHeader(data[0].data)
                if(data[data.length-1].data.length==1){
                    data.pop()
                }
                setCsvData(data)
                let verifDoublon = new Array()
                let valid=true
                selectMatch.current.forEach((r)=>{
                    if(r.value!='no'){
                        if(!verifDoublon.includes(r.value)){
                            verifDoublon.push(r.value)
                        }
                        else{
                            valid=false
                        }
                    }
                })
                if(!valid){
                    setPreSendError(t('doublonCsv'))
                }
                else{
                    let valid=true
                    let hereUpdate = false;
                    optionMatchCsv.forEach((v,index) =>{
                        if(v.match(/\*$/)){
                            if(selectMatch.current[index].value=="no") valid=false
                        }
                    })
                    if(valid || hereUpdate){
                        setShowValidButton(true)
                    }
                }
            }
            else setErrorCsv(t('noDataInCsv'))
        }else{
            setErrorCsv(t('fileCsvToLarge'))
        }
    };

    const handleOnError = (err, file, inputElem, reason) => {
        setErrorCsv(t('unknowError'))
        setCsvHeader([])
        setFileName('')
    };

    const handleOnRemoveFile = (data) => {
        setApiError(false)
        setErrorCsv(false)
        setCsvHeader([])
        setPreSendError(false)
        setFileName('')
        selectMatch.current = []
    };

    const goImport = async () => {
        setValidButton(true)
        setApiError(false)

        let matchColonne = {}
        optionMatchCsv.forEach((optm,index)=>{
            matchColonne[convert[optm.replace('*','')]]=(selectMatch.current[index].value!="no") ? selectMatch.current[index].value : null
        })

        const response  = await axios.post(process.env.REACT_APP_API_URL+"api/historique",{
            name: 'supplementListArticleAssignImport',
            totalLines: csvData.length-1,
            filename: fileName
        }).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'<br>')
                messageError=messageError.replace('undefined','');
                setApiError(messageError)
            }
            else{
                axios.post(process.env.REACT_APP_API_URL+"api/erp/supplement_list/csvimport_article/"+response.data.data.id,{
                    match: matchColonne,
                    data: csvData,
                    action:actionOnListItems
                })
                setCsvHeader([])
                setResetCsv(true)
                return(
                    swal.fire({
                        icon: 'success',
                        title: t('successInHistorique')
                    })
                )
            }
        }).catch((error) => {
            if(error=='end_session') return;
            if(error.response==undefined){
                setApiError(t('unknowError'))
            }
            else if(error.response.status==403){
                setApiError(t('forbiddenGeneral'))
            }
            else {
                setApiError(t('unknowError'))
            }
        })
        setValidButton(false)
    }

    return (
        <div className="row">
            <div className="col-12">
                <CardPerso header={t('importItemSupplementListAssign')}>
                    <div className="row">
                        <div className="col-9">
                            <div className='form-group mb-4'>
                                <label>{t('actionOnExistingListItem')}</label>
                                <select className='form-control' value={actionOnListItems} onChange={(e)=>handleChange(e)}>
                                    <option value="ajout">{t('addToTheSelection')}</option>
                                    <option value="remplacement">{t('replaceTheList')}</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-3 text-end mb-1">
                            <BtnImportModel
                                modele={
                                    {
                                        fileName:t('template')+' '+t('importItemSupplementListAssign'),
                                        data:[
                                            optionMatchCsvModelDownload
                                        ]
                                    }
                                }
                            />
                        </div>
                    </div>
                    <CSVReader
                        onDrop={handleOnDrop}
                        onError={handleOnError}
                        addRemoveButton
                        onRemoveFile={handleOnRemoveFile}
                        isReset={resetCsv}
                        config={{
                            delimiter:authParam.company.advanceparams.csv_separator,
                            encoding:authParam.company.advanceparams.csv_encode
                        }}
                    >
                        <span>{t('dropCsv')}</span>
                    </CSVReader>
                    {(csvHeader.length!=0) &&
                        <div className="col-12 mt-3">
                            <big>
                                {optionMatchCsv.map((value,index) =>
                                    <MatchCsv
                                        key={index}
                                        index={index}
                                        optionMatchCsv={optionMatchCsv}
                                        toMatch={value}
                                        csvHeader={csvHeader}
                                        ref={selectMatch}
                                        preSendError={preSendError}
                                        setPreSendError={setPreSendError}
                                        showValidButton={showValidButton}
                                        setShowValidButton={setShowValidButton}
                                        updateField= '0'
                                        isForUpdate={isForUpdate}
                                        setIsForUpdate={setIsForUpdate}
                                    />
                                )}
                            </big>
                            {(preSendError) &&
                                <div className="alert alert-danger text-center">{preSendError}</div>
                            }
                            {(apiError) ? <div className="alert alert-danger mt-3 text-center" dangerouslySetInnerHTML={{ __html: apiError }}></div> : false}
                            {(showValidButton) &&
                                <div className="col-12 text-center">
                                    <button disabled={validButton} className="btn btn-primary" onClick={() => goImport()}>
                                        {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnInsert')}
                                    </button>
                                </div>
                            }
                        </div>
                    }
                    {(errorCsv) &&
                        <div className="alert alert-danger text-center">{errorCsv}</div>
                    }
                </CardPerso>
            </div>
        </div>
    );
}

export default ImportArticleSupplementListAssign;
